module.exports = __webpack_public_path__ + "static/media/up_filled.17a65b12.svg";